module.exports = __webpack_public_path__ + "img/a.5da60d45.jpg";